import React from 'react'
import { Container, Grid, List, Segment, Flag, Item } from 'semantic-ui-react'

import { useTranslation } from 'react-i18next'
import { Link } from 'gatsby'
import { lang } from '../config'
import { urlSchema } from '../../urlSchema'

const Footer = () => {
  const [t, i18n] = useTranslation()
  let helpdeskUrl = 'https://help.speisekammer-app.de/en/'
  if (i18n.language.startsWith('de')) {
    helpdeskUrl = 'https://help.speisekammer-app.de/de/'
  }

  return (
    <Segment inverted vertical style={{ padding: '5em 0em' }}>
      <Container>
        <Grid divided inverted stackable>
          <Grid.Row>
            <Grid.Column width={8}>
              <Item content={t('footer.link.moreInfo')} />
              <List link inverted>
                <List.Item as="a" href="https://app.speisekammer-app.de/privacy/">
                  {t('footer.privacy')} App
                </List.Item>
                <List.Item as="a" href="https://app.speisekammer-app.de/termsofuse/">
                  {t('footer.tos')} App
                </List.Item>
                <List.Item as={Link} to={urlSchema.privacyStatement[i18n.language]}>
                  {t('footer.privacy')} Website
                </List.Item>
                <List.Item as="a" href="https://app.speisekammer-app.de/help/">
                  {t('footer.link.manual')} App
                </List.Item>
                <List.Item as="a" href={helpdeskUrl}>
                  {t('footer.link.knowledgeBase')}
                </List.Item>
                <List.Item as={Link} to={urlSchema.imprint[i18n.language]}>
                  {t('footer.link.imprint')}
                </List.Item>
              </List>
            </Grid.Column>

            <Grid.Column width={8}>
              <Item content={t('footer.languageChooser')} />
              {lang === 'de' && (
                <a href="https://prepper-app.com" style={{ color: 'white' }}>
                  <Flag name="us" />
                  Switch to English
                </a>
              )}
              {lang !== 'de' && (
                <a href="https://speisekammer-app.de" style={{ color: 'white' }}>
                  <Flag name="de" />
                  zu Deutsch wechseln
                </a>
              )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    </Segment>
  )
}

export default Footer
